<jqxTree #treemenu [width]="300" [source]="data" (onSelect)="select($event)"></jqxTree>